// Helpers relacionados a usuários

/**
 * Identifica APENAS os usuários internos do sistema que NÃO devem aparecer
 * em listas de atribuição/transferência:
 *  - Login/nome literal "admin"
 *  - Login/nome literal "sistema"
 *
 * IMPORTANTE: usuários do grupo "Master" (role = "master") são usuários
 * legítimos e DEVEM aparecer nas listas. Apenas os logins de serviço
 * "admin" e "sistema" são filtrados.
 */
function _isSystemUser(u) {
  if (!u) return true;
  const nome = String(u.nome || '').toLowerCase().trim();
  const login = String(u.login || u.username || '').toLowerCase().trim();
  if (nome === 'admin' || nome === 'sistema') return true;
  if (login === 'admin' || login === 'sistema') return true;
  return false;
}

/**
 * Remove usuários "de sistema" (admin/sistema) e inativos de uma lista.
 * Caso forneça `keepUserId`, esse usuário é mantido (útil para edição:
 * se uma atividade foi atribuída antes ao admin/sistema, deixar a opção
 * visível para não quebrar o select).
 */
export function filtrarUsuariosAtribuicao(users = [], keepUserId = null) {
  return (users || []).filter((u) => {
    if (keepUserId && u.id === keepUserId) return true;
    if (u.ativo === false || u.active === false) return false;
    return !_isSystemUser(u);
  });
}
